import { Card, Table } from "react-bootstrap";
import useCallApi from "../../../hooks/useCallApi";
import moment from "moment";
import { colors } from '../../../theme/variables'
import Loading from '../../../templates/UI/Loading/Loading'
import { DropdownItem } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import callAPI from "../../../helpers/callAPI";
import serverColor from "../../../helpers/serverColor";

const Leads = () => {
    const [init, setInit] = useState(true)

    const [data, setData] = useState()
    const [dataLoaded, setDataLoaded] = useState(false)

    const fetchData = async () => {
        setDataLoaded(false)
        let result = await callAPI(`mbStatus/monitoring/leads`, 'GET')
        if (result.success) {
            setData(result)
        }
        setDataLoaded(true)
    }

    useEffect(() => {
        if (init) {
            fetchData()
            setInit(false)
        }
        const interval = setInterval(() => {
            fetchData()
        }, 60000)
        return () => clearInterval(interval)
    }, [])
    return (
        <Card className="mb-3">
            <Card.Header>Leads</Card.Header>
            <Card.Body>
                {dataLoaded && data ? (
                <Table className="m-0">
                    <thead>
                        <tr>
                            <th>Status</th>
                            <th>Started</th>
                            <th>Ended</th>
                            <th>Time</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><FontAwesomeIcon className={serverColor(data.details.leadStats[0].lead_stats_period < 600 ? 'A':'C')} icon="circle" />{data.details.leadStats[0].lead_stats_period < 600 ? 'OK':'Problem'}</td>
                            <td>{moment(data.details.leadStats[0].last_start).format('YYYY-MM-DD HH:mm:ss')}</td>
                            <td>{moment(data.details.leadStats[0].last_end).format('YYYY-MM-DD HH:mm:ss')}</td>
                            <td>{data.details.leadStats[0].lead_diff} secs</td>
                        </tr>
                    </tbody>
                </Table>
                ) : (
                    <Loading />
                )}
            </Card.Body>
            <Card.Footer>
                {dataLoaded && data && (
                    <div className="text-center">
                        Last Lead Created: {moment(data.details.lastLeadCreatedDate).utc().format('YYYY-MM-DD HH:mm:ss')} ({data.details.leadCount[0].leads_created})
                    </div>
                )}
            </Card.Footer>

        </Card>
    )
}

export { Leads }